import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const AISolutions = () => {
  return (
    <main>

      {/* 🔥 HERO */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,15,30,0.85), rgba(10,15,30,0.95)), url('https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "110px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>
            AI & Intelligent Automation Solutions
          </h1>
          <p style={{ maxWidth: "720px", margin: "auto" }}>
            We design AI-powered systems that automate workflows, enhance decision-making,
            and unlock business intelligence through data-driven insights.
          </p>
        </Container>
      </section>

      {/* 🔹 INTRO */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Transform Your Business with AI</h2>
              <p>
                Artificial Intelligence is not just about automation — it’s about
                smarter systems that learn, adapt, and improve over time.
              </p>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Automate repetitive tasks",
                  "Improve decision-making with data",
                  "Enhance customer experience",
                  "Reduce operational costs"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/8386434/pexels-photo-8386434.jpeg"
                alt="AI"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 AI SERVICES */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Our AI Capabilities</h2>

          <Row className="g-4">

            {[
              {
                title: "AI Chatbots",
                desc: "Smart conversational bots for websites, WhatsApp, and customer support."
              },
              {
                title: "Process Automation",
                desc: "Automate business workflows using AI-driven logic and systems."
              },
              {
                title: "Predictive Analytics",
                desc: "Use data to predict trends, customer behavior, and outcomes."
              },
              {
                title: "Recommendation Systems",
                desc: "AI engines that personalize content and product suggestions."
              },
              {
                title: "Document AI",
                desc: "Extract, process, and analyze data from documents automatically."
              },
              {
                title: "AI Integrations",
                desc: "Integrate AI into existing software and platforms."
              }
            ].map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="gov-card p-4 h-100">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 USE CASES */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85)), url('https://images.pexels.com/photos/5475752/pexels-photo-5475752.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <h2 className="text-center mb-5">AI Use Cases</h2>

          <Row className="g-4 text-center">

            {[
              "Customer Support Automation",
              "Sales & Lead Scoring",
              "Fraud Detection",
              "Smart Reporting Dashboards",
              "Education & Learning Systems",
              "Healthcare & Data Insights"
            ].map((item, i) => (
              <Col md={4} key={i}>
                <Card className="p-4 bg-dark text-white border-0 h-100">
                  <p>{item}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔹 TECHNOLOGY STACK */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Technologies We Use</h2>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Python (AI/ML Development)",
                  "OpenAI / GPT Integration",
                  "TensorFlow / PyTorch",
                  "Azure AI Services",
                  "Data Analytics & Visualization",
                  "Automation Frameworks"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg"
                alt="AI Tech"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 WHY IGT */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Why Choose IGT for AI?</h2>

          <Row className="g-4">

            {[
              "Real AI implementation (not just theory)",
              "Custom solutions tailored to business",
              "Integration with existing systems",
              "Scalable and production-ready models",
              "Strong technical + domain expertise",
              "Continuous optimization & support"
            ].map((item, i) => (
              <Col md={4} key={i}>
                <Card className="gov-card p-4 text-center h-100">
                  <p>{item}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Ready to Implement AI?</h2>
          <p>Let’s build intelligent systems that grow your business.</p>

          <Button href="/contact" size="lg" variant="light">
            Talk to Experts
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default AISolutions;